/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminSingleSectionData, AdminSingleSectionMeta } from '@INTERFACES/admin-api/sections';

export interface SectionIntroductionTextModalDispatchParams {
    sectionData: AdminSingleSectionData;
    sectionMeta: AdminSingleSectionMeta;
    canEditDocument: boolean;
}

export interface SectionIntroductionTextModalState {
    isOpen: boolean;

    data: {
        sectionData: AdminSingleSectionData;
        sectionMeta: AdminSingleSectionMeta;
        canEditDocument: boolean;
    } | null;
}

const initialState: SectionIntroductionTextModalState = {
    isOpen: false,
    data: null,
};

export const sectionIntroductionTextModalSlice = createSlice({
    name: 'section-introduction-text-modal',
    initialState,
    reducers: {
        open(state: SectionIntroductionTextModalState, action: PayloadAction<SectionIntroductionTextModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: SectionIntroductionTextModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});

